// Components
const TheHeader = () => import(/* webpackPrefetch: true, webpackChunkName: 'the-header' */ '@/app/views/main-view/_shared/the-header/the-header.vue');
const TheSidebar = () => import(/* webpackPrefetch: true, webpackChunkName: 'the-sidebar' */ '@/app/views/main-view/_shared/the-sidebar/the-sidebar.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: 'the-footer' */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');
const Tracking = () => import(/* webpackPrefetch: true, webpackChunkName: 'tracking' */ '@/app/views/main-view/tracking/containers/tracking-container/tracking-container.vue')

// Third party libraries
import DatePicker from 'vue2-datepicker';

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';

export default {
	name: 'StyleGuideView',
	components: {
		TheHeader,
		DatePicker,
		TheSidebar,
		TheFooter,
		Tracking
	},
	mixins: [
		toastMessageMixins
	],
	data() {
		return {
			time1: '',
			time2: '',
			time3: '',
			selectedSearchableMock: '',
			searchableMockData: [
				{
					id: '1',
					dataYouWantToDisplay: 'Sample Data'
				},
				{
					id: '2',
					dataYouWantToDisplay: 'Another Data'
				},
				{
					id: '3',
					dataYouWantToDisplay: 'Some Data'
				},
				{
					id: '4',
					dataYouWantToDisplay: 'Scant Data'
				},
				{
					id: '5',
					dataYouWantToDisplay: 'Verified Data'
				}
			],
			// tables
			tableContent: [
				{
					id: 1,
					name: 'Test Name',
					address: 'Test Address',
					gender: 'Test gender'
				},
				{
					id: 2,
					name: 'Test Name',
					address: 'Test Address',
					gender: 'Test gender'
				},
				{
					id: 3,
					name: 'Test Name',
					address: 'Test Address',
					gender: 'Test gender'
				}
			],
			// tabs
			activeTab: 'Home',
			tabs : [
				{
					label: 'Home',
					id: 'home',
					active: true
				},
				{
					label: 'Profile',
					id: 'profile',
					active: false
				},
				{
					label: 'Settings',
					id: 'settings',
					active: false
				}
			]
		};
	},
	computed: {
		authPath() {
			return this.$route.path;
		},
		showSideBar() {
			return this.$store.getters.getSideBar;
		}
	},
	methods: {
		notAfterToday(date){
		  return date > new Date();
		},
		showSuccessPopups() {
			this.$swal({
				imageHeight: '30px',
				imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
				imageAlt: 'Success Dog',
				title: 'Awesome!',
				text: 'Please check your email for verification.',
				confirmButtonColor: '#4B8BFF',
				confirmButtonText: 'Got it'
			});
		},
		showErrorPopups() {
			this.$swal({
				imageHeight: '30px',
				icon: 'error',
				title: 'Failed to submit!',
				text: 'Please contact your adminitrator.',
			});
		},
		showWarningPopups() {
			this.$swal({
				imageHeight: '30px',
				title: 'Are you sure about this?',
				text: 'You won\'t be able to recover lost data!',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#4B8BFF',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Proceed'
			})
			.then(result => {
				if (result.value) {
					this.$swal({
				imageHeight: '30px',
						imageUrl: `${require('@/assets/images/_shared/success-dog.png')}`,
						imageAlt: 'Success Dog',
						title: 'Congratulations!',
						text: 'You have obliterated the unwanted data',
					});
				}
			});
		},
		showSuccessToast() {
			this.showCustomSuccessToast('Success Toast!', 'Successfully updated the pet details');
		},
		showErrorToast() {
			this.showCustomErrorToast('Failed Toast!', 'Failed to update the pet details');
		},
		showWarningToast() {
			this.showCustomWarningToast('Warning Toast!', 'You are about to update the pet details');
		},
		showInfoToast() {
			this.showCustomInfoToast('Info Toast!', 'Treatment already applied');
		},
		setActiveTab(activeTab) {
			this.activeTab = activeTab;
		}
	  }
}